import IEnum from '../interfaces/IEnum';

export const CookiesType: IEnum = {
    general: {
        title: 'lang.cookies.general',
        arrayCookies: [
            {
                name: '_hjSessionUser_XXXXXX',
                purpose: 'lang.cookies.analytics',
                supplier: '.hotjar.com',
                duration: 'lang.cookies.oneYear',
                description: 'lang.cookies.storesUniqueUserId'
            },
            {
                name: '_hjSession_XXXX',
                purpose: 'lang.cookies.analytics',
                supplier: '.hotjar.com',
                duration: 'lang.cookies.thirtyMinutes',
                description: 'lang.cookies.containsCurrentSessionData'
            },
            {
                name: '_hjIncludedInSessionSample_',
                purpose: 'lang.cookies.analytics',
                supplier: '.hotjar.com',
                duration: 'lang.cookies.thirtyMinutes',
                description: 'lang.cookies.userIncludedSampling'
            },
            {
                name: '_hjAbsoluteSessionInProgress',
                purpose: 'lang.cookies.analytics',
                supplier: '.hotjar.com',
                duration: 'lang.cookies.thirtyMinutes',
                description: 'lang.cookies.detectFirstSession'
            },
            {
                name: '_hjFirstSeen',
                purpose: 'lang.cookies.analytics',
                supplier: '.hotjar.com',
                duration: 'lang.cookies.session',
                description: 'lang.cookies.detectUserFirstSession'
            }
        ]
    },
    izenpe: {
        title: 'lang.cookies.izenpe',
        arrayCookies: [
            {
                name: 'JSESSIONID',
                purpose: 'lang.cookies.tecnical',
                supplier: '.izenpe.com',
                duration: 'lang.cookies.session',
                description: 'lang.cookies.storesSessionData'
        }]
    },
    clave: {
        title: 'lang.cookies.clave',
        arrayCookies: [
            {
                name: 'clave2Sso',
                purpose: 'lang.cookies.tecnical',
                supplier: '.sepasarela.clave.gob.es',
                duration: 'lang.cookies.oneHour',
                description: 'lang.cookies.storesUserSession'
            },
            {
                name: 'JSESSIONID',
                purpose: 'lang.cookies.tecnical',
                supplier: 'pasarela.clave.gob.es',
                duration: 'lang.cookies.session',
                description: 'lang.cookies.storesSessionData'
            },
            {
                name: 'dtCookie',
                purpose: 'lang.cookies.thirdPartyAnalytics',
                supplier: '.clave.gob.es',
                duration: 'lang.cookies.session',
                description: 'lang.cookies.dynatraceAnalysisCookie'
            },
            {
                name: 'dtPC',
                purpose: 'lang.cookies.thirdPartyAnalytics',
                supplier: '.clave.gob.es',
                duration: 'lang.cookies.session',
                description: 'lang.cookies.dynatraceIdentifyEndpoints'
            },
            {
                name: 'dtSa',
                purpose: 'lang.cookies.thirdPartyAnalytics',
                supplier: '.clave.gob.es',
                duration: 'lang.cookies.session',
                description: 'lang.cookies.dynatraceStoresActions'
            },
            {
                name: 'rxVisitor',
                purpose: 'lang.cookies.thirdPartyAnalytics',
                supplier: '.clave.gob.es',
                duration: 'lang.cookies.session',
                description: 'lang.cookies.dynatraceAnalysisCookie'
            },
            {
                name: 'rxvt',
                purpose: 'lang.cookies.thirdPartyAnalytics',
                supplier: '.clave.gob.es',
                duration: 'lang.cookies.session',
                description: 'lang.cookies.dynatraceSpecifiesSessionExpiration'
        }]
    },
    aoc: {
        title: 'lang.cookies.aoc',
        arrayCookies: [
            {
                name: 'JSESSIONID',
                purpose: 'lang.cookies.tecnical',
                supplier: '.aoc.cat',
                duration: 'lang.cookies.session',
                description: 'lang.cookies.storesSessionData'
        }]
    }
};
